/* eslint no-console:0 */

import Rails from "@rails/ujs";
import $ from "jquery";
import Turbolinks from "turbolinks";
import "foundation-sites";
import * as ActiveStorage from "@rails/activestorage";

// Javascript
import "owl.carousel";

// Styles
import "owl.carousel/dist/assets/owl.carousel.css";
import "application.scss";

// Images
// Emit every file in app/webpacker/images so any of them can be referenced with
// image_pack_tag. Listing them individually meant a view could reference an
// image that was never bundled -- images/004-x-logo.svg was already in that state.
require.context("../images", true, /\.(png|jpe?g|gif|svg|ico|webp)$/);

Rails.start();
Turbolinks.start();
ActiveStorage.start();

$(document).on("turbolinks:load", function () {
  $(document).foundation();

  if ($("#testimonialCarousel").length) {
    $("#testimonialCarousel").owlCarousel({
      autoplay: true,
      autoplayHoverPause: true,
      dots: true,
      items: 1,
      loop: true,
      margin: 0,
    });
  }

  if ($("#bannerCarousel").length) {
    $("#bannerCarousel").owlCarousel({
      autoplay: true,
      items: 1,
      dots: false,
      loop: true,
      margin: 0,
    });
  }

  if ($("#benefitsCarousel").length) {
    $("#benefitsCarousel").owlCarousel({
      autoplay: true,
      autoplayHoverPause: true,
      dots: true,
      loop: true,
      margin: 24,
      responsive: {
        0: {
          items: 1,
        },
        640: {
          items: 2,
        },
      },
    });
  }

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 20) {
      $(".home-page").addClass("fixed-header");
    } else {
      $(".home-page").removeClass("fixed-header");
    }
  });
});
